import type { ScreenModule } from "../../../app/screen-module";
import { BoardPage } from "./Page";

/**
 * 発注ボードは品質問題のためナビから外し、パスも /app/board へ退避。
 * 新規の指示導線はワークスペース Visual（defaultUcs Session）を使う。
 */
export default {
	id: "end-user.board",
	path: "/app/board",
	area: "end-user",
	label: "発注ボード（廃止予定）",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	demo: { allowed: true, constraints: ["no-persist"] },
	enabled: true,
	component: BoardPage,
} satisfies ScreenModule;
